export const RouteId = {
  ACCOUNT: 'account',
  OLD_ACCOUNT: 'oldAccount',
  WORKSPACE_BILLING: 'workspaceBilling',
  BILLING: 'billing',
  BLANK: 'blank',
  BOARD: 'board',
  BOARD_OLD: 'boardOld',
  BOARD_REFERRAL: 'boardReferral',
  CARD: 'card',
  CARD_OLD: 'cardOld',
  CARD_AND_BOARD_OLD: 'cardAndBoardOld',
  CREATE_FIRST_BOARD: 'createFirstBoard',
  WELCOME_TO_TRELLO: 'welcomeToTrello',
  DOUBLE_SLASH: 'doubleSlash',
  ENTERPRISE_ADMIN: 'enterpriseAdmin',
  ENTERPRISE_ADMIN_TAB: 'enterpriseAdminTab',
  ERROR_PAGE: 'errorPage',
  GET_APP: 'getApp',
  GO: 'go',
  INBOX: 'inbox',
  OLD_INBOX: 'oldInbox',
  INVITE_ACCEPT_BOARD: 'inviteAcceptBoard',
  INVITE_ACCEPT_TEAM: 'inviteAcceptTeam',
  INVITE_ACCEPT_REFERRAL: 'inviteAcceptReferral',
  MEMBER_ACTIVITY: 'memberActivity',
  OLD_MEMBER_ACTIVITY: 'oldMemberActivity',
  MEMBER_ALL_BOARDS: 'memberAllBoards',
  OLD_MEMBER_ALL_BOARDS: 'oldMemberAllBoards',
  MEMBER_CARDS: 'memberCards',
  OLD_MEMBER_CARDS: 'oldMemberCards',
  MEMBER_CARDS_FOR_ORG: 'memberCardsForOrg',
  OLD_MEMBER_CARDS_FOR_ORG: 'oldMemberCardsForOrg',
  MEMBER_HOME: 'memberHome',
  MEMBER_HOME_WORKSPACE_BOARDS: 'memberHomeBoards',
  OLD_MEMBER_HOME_WORKSPACE_BOARDS: 'oldMemberHomeBoards',
  MEMBER_PROFILE_SECTION: 'memberProfile',
  MEMBER_TASKS: 'memberTasks',
  MEMBER_LABS: 'memberLabs',
  OLD_MEMBER_LABS: 'oldMemberLabs',
  OLD_ORGANIZATION_GUESTS: 'oldOrganizationGuests',
  OLD_ORGANIZATION_MEMBERS: 'oldOrganizationMembers',
  OLD_ORGANIZATION_REQUESTS: 'oldOrganizationRequests',
  ORGANIZATION_BOARDS: 'organizationBoards',
  ORGANIZATION_BY_ID: 'organizationById',
  ORGANIZATION_EXPORT: 'organizationExport',
  OLD_ORGANIZATION_EXPORT: 'oldOrganizationExport',
  ORGANIZATION_FREE_TRIAL: 'organizationFreeTrial',
  OLD_ORGANIZATION_FREE_TRIAL: 'oldOrganizationFreeTrial',
  ORGANIZATION_GUESTS: 'organizationGuests',
  ORGANIZATION_REQUESTS: 'organizationRequests',
  ORGANIZATION_MEMBER_CARDS: 'organizationMemberCards',
  ORGANIZATION_MEMBERS: 'organizationMembers',
  ORGANIZATION_POWER_UPS: 'organizationPowerUps',
  OLD_ORGANIZATION_POWER_UPS: 'oldOrganizationPowerUps',
  ORGANIZATION_TABLES: 'organizationTables',
  OLD_ORGANIZATION_TABLES: 'oldOrganizationTables',
  POWER_UP_ADMIN: 'powerUpAdmin',
  APPS_ADMIN: 'appsAdmin',
  POWER_UP_EDIT: 'powerUpEdit',
  APPS_ADMIN_EDIT: 'appsAdminEdit',
  POWER_UP_PUBLIC_DIRECTORY: 'powerUpPublicDirectory',
  PROFILE: 'profile',
  REDEEM: 'redeem',
  SEARCH: 'search',
  OPEN_SOURCE_ATTRIBUTIONS: 'openSourceAttributionsPage',
  SELECT_ORG_TO_UPGRADE: 'selectOrgToUpgrade',
  SELECT_TEAM_TO_UPGRADE: 'selectTeamToUpgrade',
  SHORTCUTS: 'shortcuts',
  SHORTCUTS_OVERLAY: 'shortcutsOverlay',
  TEMPLATES: 'templates',
  TEMPLATES_RECOMMEND: 'templatesRecommend',
  TO: 'to',
  USER_OR_ORG: 'userOrOrg',
  WORKSPACE_DEFAULT_CUSTOM_TABLE_VIEW: 'workspaceDefaultCustomTableView',
  OLD_WORKSPACE_DEFAULT_CUSTOM_TABLE_VIEW: 'oldWorkspaceDefaultCustomTableView',
  WORKSPACE_VIEW: 'workspaceView',
  WORKSPACE_DEFAULT_CUSTOM_CALENDAR_VIEW: 'workspaceDefaultCustomCalendarView',
  OLD_WORKSPACE_DEFAULT_CUSTOM_CALENDAR_VIEW:
    'oldWorkspaceDefaultCustomCalendarView',
  MEMBER_ACCOUNT: 'memberAccount',
  MEMBER_AI_SETTINGS: 'memberAiSettings',
} as const;
export type RouteIdType = (typeof RouteId)[keyof typeof RouteId];
